import { AppInstallPermission, StargatePermissionId } from "./stargate.types";
import { toMarketplaceProducts, toStargateProducts } from "./stargate.utils";
export default function stargateMarketplaceMethods(self) {
  return {
    async appInstallPermission(product, cloudId) {
      const productAdminPermittedPromise = self.permitted(StargatePermissionId.MANAGE, "ari:cloud:".concat(product, "::site/").concat(cloudId));
      const siteAdminPermittedPromise = self.permitted(StargatePermissionId.MANAGE, "ari:cloud:platform::site/".concat(cloudId));
      const [productAdminPermission, siteAdminPermission] = await Promise.all([productAdminPermittedPromise, siteAdminPermittedPromise]);
      return siteAdminPermission.permitted ? AppInstallPermission.CAN_INSTALL_FREE_AND_PAID : productAdminPermission.permitted ? AppInstallPermission.CAN_INSTALL_FREE_ONLY : AppInstallPermission.CANNOT_INSTALL;
    },

    async availableSites(products) {
      const stargateProducts = toStargateProducts(products);
      const {
        sites
      } = await self.availableSites(stargateProducts);
      const marketplaceSites = sites.map(site => ({ ...site,
        products: toMarketplaceProducts(site.products)
      }));
      return {
        sites: marketplaceSites
      };
    }

  };
}